import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { IAuditDto } from '../../../../models/IAuditDto';
import { IDriftEntryDto } from '../../../../models/features/schema-drift/IDriftEntryDto';
import { AuditProfileService } from '../../../../services/audit-profile/audit-profile.service';
import { BaseComponent } from '../../../base/base.component';
import { AuditUtilityService } from '../../../../services/audit-utility/audit-utility.service';
import { HeaderService } from 'src/app/services/_app/header/header.service';
import { AuditInfrastructureService } from '../../../../services/audit-infrastructure/audit-infrastructure.service';
import { AuditLighthouseService } from '../../../../services/audit-lighthouse/audit-lighthouse.service';

@Component({
  selector: 'app-audit',
  templateUrl: './audit.component.html',
  styleUrls: ['./audit.component.css'],

})
export class AuditComponent extends BaseComponent {

  currentConnectionString: string = '';
  isConnectionModalOpen: boolean = false;
  isAlertModal: boolean = false;
  isModalopen: boolean = false;
  isViewAuditLog: boolean = false;
  auditMetricsData: any;
  skeleton: boolean = true;
  auditProfileData: any;

  constructor(private auditProfileService: AuditProfileService,
    private auditUtilityService: AuditUtilityService,
    private auditInfrastructureService: AuditInfrastructureService,
    private auditLighthouseService: AuditLighthouseService,
    private headerService: HeaderService,
    private router: Router) {
    super();
  }

  override async ngOnInit() {
    await this.getAuditProfiles();
  }

  public auditProfiles: any = [];

  items: MenuItem[] = [
    {
      label: 'Lighthouse Dashboard',
      icon: 'pi pi-sun',
      routerLink: '/lighthouse-dashboard',
    },
    {
      label: 'See full data report',
      icon: 'pi pi-eye',
    },
    {
      label: 'Update connection string',
      icon: 'pi pi-cloud-upload',
    },
    {
      label: 'Delete Audit',
      icon: 'pi pi-trash'
    }
  ];

  toggleItems: MenuItem[] = [
    // {
    //   label: 'Lighthouse Dashboard',
    //   icon: 'pi pi-sun',
    //   routerLink: '/lighthouse-dashboard',
    // },
    //{
    //  label: 'See full data report',
    //  icon: 'pi pi-eye',
    //},
    {
      label: 'Update connection string',
      icon: 'pi pi-cloud-upload',
    },
    {
      label: 'Delete Audit',
      icon: 'pi pi-trash'
    }
  ];

  headercheckbox: boolean = false;
  listcheckbox: boolean = false;
  public errorMessageTitle: string = '';
  public errorDisplayMessage: string = '';
  public errorIsShowButton: boolean = false;
  public errorButtonClickCallback: any = null;
  public errorButtonText: string = 'Create audit now!';
  public isShowGenericAlertModal: boolean = false;
  public isSyncing: boolean = false;
  public syncMessage: string = 'Syncing...';
  public selectedAuditProfileId: string = '';

  private async getAuditProfiles() {
    this.headerService.setSpinner(true);
    await this.auditProfileService.getAuditProfiles().then((x: Array<IAuditDto>) => {
      if (x.length === 0) {
        this.isShowGenericAlertModal = true;
        //alert(`No audits found, let's create your first one now!`);
        this.errorMessageTitle = 'No audits yet!';
        this.errorDisplayMessage = `No audits found, let's create your first one now!`;
        this.errorIsShowButton = false; //TODO: Change to "true"
        this.errorButtonClickCallback = () => { // TODO: Create BehaviorSubject to allow header component to respond to click event to auto-trigger the Audit Dialog open
          alert('I was clicked');
        };
      }

      x.map((a: any) => {
        this.auditProfiles.push({
          Id: a.Id,
          CustomerId: a.CustomerId,
          ConnectionString: a.ConnectionString,
          DatabaseName: a.DatabaseName,
          ExcludeTables: a.ExcludeTables,
          AuditMetrics: a.AuditMetrics,
          AuditMetricsSummaryBrief: this.getAuditResultsSummaryBrief(a.AuditMetrics[0]),
          AuditTablesCreated: this.getAuditTableCreatedCount(a.AuditMetrics[0]),
          IsSyncing: false
        });
      });

      this.skeleton = false;
      this.headerService.setSpinner(false);
    }).catch((err: any) => {
      console.log(err);
      this.skeleton = false;
      this.headerService.setSpinner(false);
    });
  }

  goToLighthouseDashboard(auditProfile: any) {
    let _ = this.Audit;
    _ = auditProfile;
    this.Audit = _;

    this.router.navigate(['/lighthouse-dashboard']);
  }

  viewAuditMetrics(auditProfile: IAuditDto) {
    this.isViewAuditLog = true;
    this.auditMetricsData = auditProfile;
    //this.auditMetricsData.isModalOpenFromAuditComp = true;
  }

  public async deleteAuditProfile(auditProfileId: string) {
    // TODO: Fix
    await this.auditProfileService.deleteAuditProfile(auditProfileId).then((x: any) => {
      // remove the deleted audit profile from the list
      debugger;
      this.auditProfiles = [];
      this.getAuditProfiles();
      this.headerService.setSpinner(false);
    }).catch((err: any) => {
      console.log(err);
      this.headerService.setSpinner(false);
    });
  }

  public async updateConnectionString(connectionString: string, auditProfile: IAuditDto) {

    if (connectionString == null || connectionString == "") {
      // alert("User cancelled the prompt.");
      this.isConnectionModalOpen = false;
      return;
    }

    let _ = {
      Id: auditProfile.Id,
      ConnectionString: connectionString
    };

    await this.auditUtilityService.updateConnectionString(_).then((x: any) => {
      this.refreshAuditProfiles();
    }).catch((err: any) => {
      console.log(err);
    });

    this.currentConnectionString = '';
    this.isConnectionModalOpen = false;

  }

  public async openConnectionModal() {
    this.isConnectionModalOpen = true;

  }

  public async syncDatabase(profile: any) {
    profile.IsSyncing = true;
    //profile.syncMessage = 'Columns changes...';
    try {
      await this.syncDatabase2(profile);
    } catch (e) {
      profile.syncMessage = 'Table changes...';
      await this.auditInfrastructureService.syncAuditDatabase(profile.Id).then(async () => {
        await this.syncDatabase2(profile);
      });
    }

  }

  public async syncDatabase2(profile: any) {
    profile.IsSyncing = true;
    profile.syncMessage = 'Columns...';
    await this.auditInfrastructureService.syncAuditDatabaseColumns(profile.Id).then(async () => {
      profile.syncMessage = 'DBs...';
      await this.auditInfrastructureService.syncAuditDatabase(profile.Id).then(async () => {
        profile.syncMessage = 'Base...';
        await this.auditLighthouseService.syncAuditDatabase(profile.Id).then(async () => {
          profile.syncMessage = 'Cleaning...';
          await this.auditUtilityService.cleanAuditProfile(profile.Id).then(async () => {
            profile.IsSyncing = false;
            profile.syncMessage = '';
          });
        });
      });
    });
  }

  public async seeSchemaDrift(auditProfileId: string) {
    this.AuditProfileId = auditProfileId;
    this.router.navigate(['/schema-drift-dashboard']);
  }

  refreshAuditProfiles() {
    this.auditProfiles = [];
    this.getAuditProfiles();
  }

  getAuditResultsSummaryBrief(input: string): string {
    // Using a regular expression to extract the desired information
    const successRateMatch = input.match(/Success Rate: (\d+%)/);
    const failureRateMatch = input.match(/Failure Rate: (\d+%)/);
    const auditTablesCreatedMatch = input.match(/Audit Tables Created: (\d+)/);

    // Extracting the captured groups (values) from the regex matches
    const successRate = successRateMatch ? successRateMatch[1] : "N/A";
    const failureRate = failureRateMatch ? failureRateMatch[1] : "N/A";
    const auditTablesCreated = auditTablesCreatedMatch ? auditTablesCreatedMatch[1] : "N/A";

    // Constructing the result string
    return `Success Rate: ${successRate}, Failure Rate: ${failureRate}, Audit Tables Created: ${auditTablesCreated}`;
  }

  getAuditTableCreatedCount(input: string): string {
    const auditTablesCreatedMatch = input.match(/Audit Tables Created: (\d+)/);
    const auditTablesCreated = auditTablesCreatedMatch ? auditTablesCreatedMatch[1] : "N/A";

    return auditTablesCreated;
  }

  // TODO: What is this?
  headerCheckbox() {
    this.headercheckbox = !this.headercheckbox;
  }

  // TODO: What is this?
  listCheckbox() {
    this.listcheckbox = !this.listcheckbox;
  }

  openMenu(menu: any, event: any) {
    menu.toggle(event);
  }

  dialogCloseEmitter(event: boolean) {
    this.isModalopen = event;
  }

  auditMetricsDialogCloseEmitter(event: boolean) {
    this.isViewAuditLog = false;
  }


  //open alert modal
  deleteAuditProfileAlert(id: string) {
    console.log("clicked");
    this.isAlertModal = true;
    this.selectedAuditProfileId = id;
  }

  //handling alert modal
  handleAlertModal(res: any) {
    if (!res.isDelete) { this.isAlertModal = res?.isModalVisibility }
    else {
      debugger;
      this.deleteAuditProfile(this.selectedAuditProfileId);
      this.isAlertModal = res?.isModalVisibility;
    }
  }
}
